import React from "react";
import { AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Disclaimer = ({ compact = false }) => {
  const { t } = useLang();
  return (
    <div
      data-testid="educational-disclaimer-banner"
      className={`flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 text-amber-800 ${compact ? "p-3 text-xs" : "p-4 text-sm"}`}
    >
      <AlertTriangle className="mt-0.5 shrink-0" size={compact ? 14 : 18} />
      <p className="leading-relaxed">{t("disclaimer")}</p>
    </div>
  );
};

export default Disclaimer;
